<div class="toolbar-section">
  <div class="toolbar-control-content">
    <div class="horizontal-container">
      <div class="root-container">
        <div class="inline-command-bar">
          <div class="action-list-control-container">
            <div class="horizontal-flex-container">

              <!-- Toggle filter with populated operator -->
              <div class="command-bar-button-container">
                <nts-text-button [class.active]="zoomParametersViewModel.showFilterWithPopulatedOperator"
                  [title]="zoomParametersViewModel.filterWithPopulatedOperatorButtonTitle" [icon]="'task-list'"
                  (onClicked)="zoomParametersViewModel.showFilterWithPopulatedOperator = !zoomParametersViewModel.showFilterWithPopulatedOperator">
                </nts-text-button>
              </div>

              <!-- Toggle selection in filter -->
              <div class="command-bar-button-container">
                <nts-text-button [class.active]="zoomParametersViewModel.showSelectionsFilterOptions"
                  [title]="zoomParametersViewModel.selectionsFiltersOptionsButtonTitle" [icon]="'eye-empty'"
                  (onClicked)="zoomParametersViewModel.showSelectionsFilterOptions = !zoomParametersViewModel.showSelectionsFilterOptions">
                </nts-text-button>
              </div>

              <!-- Toggle advanced command -->
              <div class="command-bar-button-container">
                <nts-text-button [class.active]="zoomParametersViewModel.showAdvancedFiltersOptions"
                  [title]="zoomParametersViewModel.advancedButtonTitle" [icon]="'fx-rounded'"
                (onClicked)="zoomParametersViewModel.toggleAdvancedFilters()"></nts-text-button>
              </div>

              <!-- Toggle sorting -->
              <div class="command-bar-button-container">
                <nts-text-button [class.active]="zoomParametersViewModel.showSortingGroups"
                  [title]="zoomParametersViewModel.sortingGroupButtonTitle" icon="sort"
                (onClicked)="zoomParametersViewModel.toggleSortingGroups()"></nts-text-button>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- Clear filters command -->
      <div class="horizontal-flex-container-item-layout">
        <div class="command-bar-button-container">
          <nts-text-button [title]="zoomParametersViewModel.clearCommand.tooltip"
            [label]="zoomParametersViewModel.clearCommand.displayName"
            [isDisabled]="!(zoomParametersViewModel.clearCommand.canExecute$ | async)"
          (onClicked)="zoomParametersViewModel.clearCommand.execute()"></nts-text-button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="zoom-parameters-content zoom-parameter-content-mobile"
  [class.is-hidden]="zoomParametersViewModel.showSortingGroups">
  <div #parameterLabels class="parameter-column parameter-column-labels">
    <!-- <div class="zoom-parameter-label">{{ zoomParametersViewModel.headerPropertyName }}</div> -->
    @for (filter of (zoomParametersViewModel.filters | zoomAvailablesFilter: zoomParametersViewModel.showFilterWithPopulatedOperator); track filter) {
      <div
        class="zoom-filter-name level-{{filter.metaData.level}}">
        <div class="header">
          <div class="zoom-filter-name-container">
            @if (zoomParametersViewModel.showSelectionsFilterOptions) {
              <nts-base-checkbox-text-box
                (onChange)="zoomParametersViewModel.notifyModified()"
                [(checkStatus)]="filter.isSelected"
                [label]="filter.propertyNameMap.displayName"
                [isDisabled]="!filter.isSelectable">
              </nts-base-checkbox-text-box>
            }
            <nts-label-box (click)="findExternal($event, filter)"
              [class.label-multiline]="filter.operator.currentValue == zoomParametersViewModel.filterOperators.Between"
              [class.zoom-label]="filter.externalDomainModelNameToZoom !== '' && filter.islocked === false"
              [title]="filter.propertyNameMap.displayName"
            [label]="filter.propertyNameMap.displayName"></nts-label-box>
          </div>
          @if (filter.externalDomainModelNameToZoom !== '' && filter.islocked === false) {
            <nts-text-button
              [icon]="(filter.isLoading$ | async) ? 'refresh-animated' : 'search'"
              (onClicked)="findExternal($event, filter)">
            </nts-text-button>
          }
          @if (hasChildren(filter) && !zoomParametersViewModel.showFilterWithPopulatedOperator && filter.isExternalRemote == false && filter.islocked === false) {
            <nts-text-button
              [title]="((filter.isCollapsed$ | async) ? 'std_ExpandableShowMore_Description' : 'std_ExpandableShowLess_Description') | NTSTranslate"
              [icon]="(filter.isCollapsed$ | async) ? 'eye-alt' : 'eye-close'"
              (onClicked)="toggleChildrenVisibility(filter)">
            </nts-text-button>
          }
          <nts-text-button
            [title]="'Espandi/Riduci'" (onClicked)="toggleExpandedFilter(filter)"
            [icon]="filter.isExpanded ? 'compress' : 'de-compress'">
          </nts-text-button>
        </div>
        @if (filter.isExpanded) {
          <div class="footer">
            <div #parameterOperators class="parameter-column parameter-column-operators">
              <!-- <div class="zoom-parameter-label">{{ zoomParametersViewModel.headerOperatorName }}</div> -->
              <div class="filter-operator">
                <nts-zoom-filter-operator-text-box [operator]="filter.operator"></nts-zoom-filter-operator-text-box>
              </div>
            </div>
            <div #parameterValues class="parameter-column parameter-values">
              <div class="filter-value-container">
                @if (!(filter.isOperatorSupported | async)) {
                  <div class="filter-value" #filters>
                    @if (!filter.showVariables) {
                      <div class="filter-value-list" @openClose>
                        <div class="unsupported-operator">Operatore non supportato</div>
                      </div>
                    }
                  </div>
                }
                @if (filter.isOperatorSupported | async) {
                  @if (filter.operator.currentValue != zoomParametersViewModel.filterOperators.In) {
                    <div class="filter-value" #filters
                      [ngClass]="{'advanced-filters-show': zoomParametersViewModel.showAdvancedFiltersOptions}">
                      @if (!filter.showVariables) {
                        <div class="filter-value-list" @openClose>
                          @if (isFilterString(filter.filterValue) && !filter.showVariables) {
                            @if (isStringZoomFilterViewModel(filter)) {
                              <nts-zoom-filter-string-text-box
                                [filter]="filter"
                                [propertyViewModel]="filter.filterValue" (focus)="parameterFocus($event, filter)"
                                (keyDown)="keyDown($event)">
                              </nts-zoom-filter-string-text-box>
                            }
                          }
                          @if (isFilterGuid(filter.filterValue) && !filter.showVariables) {
                            @if (isGuidZoomFilterViewModel(filter)) {
                              <nts-zoom-filter-string-text-box
                                [filter]="filter"
                                [validateChipsFunc]="guidMaskSettings.validateMaskOnBlurFunc"
                                [maskSettings]="guidMaskSettings"
                                [propertyViewModel]="filter.filterValue" (focus)="parameterFocus($event, filter)"
                                (keyDown)="keyDown($event)">
                              </nts-zoom-filter-string-text-box>
                            }
                          }
                          @if (isFilterNumeric(filter.filterValue) && !filter.showVariables) {
                            @if (isNumericZoomFilterViewModel(filter)) {
                              <nts-zoom-filter-numeric-text-box
                                [filter]="filter"
                                [propertyViewModel]="filter.filterValue" [updateOnBlur]="true"
                                (focus)="parameterFocus($event, filter)"
                                (keyDown)="keyDown($event)">
                              </nts-zoom-filter-numeric-text-box>
                            }
                          }
                          @if (isFilterExternal(filter.filterValue) && !filter.showVariables) {
                            @if (isExternalZoomFilterViewModel(filter)) {
                              <nts-zoom-filter-external-text-box
                                [filter]="filter"
                                [propertyViewModel]="filter.filterValue" [updateOnBlur]="true"
                                (focus)="parameterFocus($event, filter)"
                                (keyDown)="keyDown($event)">
                              </nts-zoom-filter-external-text-box>
                            }
                          }
                          @if (isFilterBool(filter.filterValue) && !filter.showVariables) {
                            @if (isBoolZoomFilterViewModel(filter)) {
                              <nts-zoom-filter-bool-text-box
                                [filter]="filter"
                                [propertyViewModel]="filter.filterValue">
                              </nts-zoom-filter-bool-text-box>
                            }
                          }
                          @if (isFilterDate(filter.filterValue) && !filter.showVariables) {
                            @if (isDateTimeZoomFilterViewModel(filter)) {
                              <nts-zoom-filter-date-text-box
                                [filter]="filter"
                                [propertyViewModel]="filter.filterValue">
                              </nts-zoom-filter-date-text-box>
                            }
                          }
                          @if (isFilterDateTimeOffset(filter.filterValue) && !filter.showVariables) {
                            @if (isDateTimeZoomFilterViewModel(filter)) {
                              <nts-zoom-filter-date-offset-text-box
                                [filter]="filter"
                                [propertyViewModel]="filter.filterValue">
                              </nts-zoom-filter-date-offset-text-box>
                            }
                          }
                          @if (isFilterEnum(filter.filterValue) && !filter.showVariables) {
                            @if (isEnumZoomFilterViewModel(filter)) {
                              <nts-zoom-filter-enum-text-box
                                [filter]="filter"
                                [propertyViewModel]="filter.filterValue">
                              </nts-zoom-filter-enum-text-box>
                            }
                          }
                        </div>
                      }
                      @if (filter.showVariables) {
                        <div class="variables-container" @openClose>
                          @if (filter.showVariables) {
                            <nts-base-enum-text-box [value]="filter.filterVariableValue"
                              optionLabel="description"
                              dataKey="key" [options$]="filter.filterVariables$" [appendTo]="'body'"
                              [isDisabled]="filter.OperatorDoesNotRequireValue"
                              [placeholder]="zoomParametersViewModel.variablesPlaceholderTitle"
                              (onChange)="zoomParametersViewModel.onFilterVariableChange($event, filter)"
                              (onBlur)="zoomParametersViewModel.onFilterVariableBlur(filter)" [isNullable]="true">
                            </nts-base-enum-text-box>
                          }
                        </div>
                      }
                      @if (zoomParametersViewModel.showAdvancedFiltersOptions && filter.filterVariables$.value?.length > 0) {
                        <div class="variables-button-container"
                          >
                          @if (zoomParametersViewModel.showAdvancedFiltersOptions) {
                            <nts-text-button
                              [title]="zoomParametersViewModel.variablesButtonTitle" [icon]="'filter'"
                              [class.var-visible]="filter.showVariables"
                              (onClicked)="zoomParametersViewModel.toogleVariablesVisibility(filter)">
                            </nts-text-button>
                          }
                        </div>
                      }
                    </div>
                  }
                  <!-- Between -->
                  @if (filter.operator.currentValue == zoomParametersViewModel.filterOperators.Between) {
                    <div class="filter-value"
                      #filters
                      [ngClass]="{'advanced-filters-show': zoomParametersViewModel.showAdvancedFiltersOptions, 'filter-value-between':filter.operator.currentValue == zoomParametersViewModel.filterOperators.Between }">
                      @if (!filter.showVariables2) {
                        <div class="filter-value-list" @openClose>
                          @if (isFilterString(filter.filterValue) && filter.operator.currentValue == zoomParametersViewModel.filterOperators.Between && !filter.showVariables2) {
                            <div
                              >
                              @if (isStringZoomFilterViewModel(filter)) {
                                <nts-zoom-filter-string-text-box [filter]="filter"
                                  [propertyViewModel]="getFilterString(filter.filterValue2)"
                                  [updateOnBlur]="true"
                                  (focus)="parameterFocus($event, filter)" (keyDown)="keyDown($event)"
                                  [ngClass]="'filter-value-text-between'">
                                </nts-zoom-filter-string-text-box>
                              }
                            </div>
                          }
                          @if (isFilterNumeric(filter.filterValue) && filter.operator.currentValue == zoomParametersViewModel.filterOperators.Between && !filter.showVariables2) {
                            <div
                              >
                              @if (isNumericZoomFilterViewModel(filter)) {
                                <nts-zoom-filter-numeric-text-box [filter]="filter"
                                  [propertyViewModel]="getFilterNumeric(filter.filterValue2)"
                                  [updateOnBlur]="true"
                                  (focus)="parameterFocus($event, filter)" (keyDown)="keyDown($event)"
                                  [ngClass]="'filter-value-text-between'">
                                </nts-zoom-filter-numeric-text-box>
                              }
                            </div>
                          }
                          @if (isFilterDate(filter.filterValue) && filter.operator.currentValue == zoomParametersViewModel.filterOperators.Between && !filter.showVariables2) {
                            <div
                              >
                              @if (isExternalZoomFilterViewModel(filter)) {
                                <nts-zoom-filter-date-text-box [propertyViewModel]="getFilterDate(filter.filterValue2)"
                                  [ngClass]="'filter-value-text-between'">
                                </nts-zoom-filter-date-text-box>
                              }
                            </div>
                          }
                          @if (isFilterExternal(filter.filterValue) && filter.operator.currentValue == zoomParametersViewModel.filterOperators.Between && !filter.showVariables2) {
                            <div
                              >
                              @if (isExternalZoomFilterViewModel(filter)) {
                                <nts-zoom-filter-external-text-box
                                  [filter]="filter"
                                  [ngClass]="'filter-value-text-between'"
                                  [updateOnBlur]="true"
                                  [propertyViewModel]="getExternalZoomPropertyViewModel(filter.filterValue2)"
                                  (keyDown)="keyDown($event)"
                                  (focus)="parameterFocus($event, filter)">
                                </nts-zoom-filter-external-text-box>
                              }
                            </div>
                          }
                          @if (isFilterDateTimeOffset(filter.filterValue) && filter.operator.currentValue == zoomParametersViewModel.filterOperators.Between && !filter.showVariables2) {
                            <div
                              >
                              @if (isDateTimeZoomFilterViewModel(filter)) {
                                <nts-zoom-filter-date-offset-text-box
                                  [propertyViewModel]="getFilterDateTimeOffset(filter.filterValue2)"
                                  [ngClass]="'filter-value-text-between'">
                                </nts-zoom-filter-date-offset-text-box>
                              }
                            </div>
                          }
                        </div>
                      }
                      @if (filter.showVariables2) {
                        <div class="variables-container" @openClose>
                          @if (filter.showVariables2 && filter.operator.currentValue == zoomParametersViewModel.filterOperators.Between) {
                            <div class="mt-1"
                              @openClose>
                              @if (filter.showVariables2) {
                                <nts-base-enum-text-box [value]="filter.filterVariable2Value"
                                  optionLabel="description" dataKey="key" [options$]="filter.filterVariables$" [appendTo]="'body'"
                                  [isDisabled]="filter.OperatorDoesNotRequireValue"
                                  [placeholder]="zoomParametersViewModel.variablesPlaceholderTitle"
                                  (onChange)="zoomParametersViewModel.onFilterVariable2Change($event, filter)" [isNullable]="true"
                                  (onBlur)="zoomParametersViewModel.onFilterVariable2Blur(filter)" [isNullable]="true">
                                </nts-base-enum-text-box>
                              }
                            </div>
                          }
                        </div>
                      }
                      @if (zoomParametersViewModel.showAdvancedFiltersOptions && filter.filterVariables$.value?.length > 0) {
                        <div class="variables-button-container"
                          >
                          @if (zoomParametersViewModel.showAdvancedFiltersOptions && filter.operator.currentValue == zoomParametersViewModel.filterOperators.Between) {
                            <nts-text-button
                              [title]="zoomParametersViewModel.variablesButtonTitle" [icon]="'filter'"
                              [class.var-visible]="filter.showVariables2"
                              (onClicked)="zoomParametersViewModel.toogleVariables2Visibility(filter)">
                            </nts-text-button>
                          }
                        </div>
                      }
                    </div>
                  }
                  <!-- In -->
                  @if (filter.operator.currentValue == zoomParametersViewModel.filterOperators.In) {
                    <div class="filter-value"
                      #filters>
                      @if (!filter.showVariables) {
                        <div class="filter-value-list" @openClose>
                          @if (isFilterString(filter.filterValue) && !filter.showVariables) {
                            @if (isStringZoomFilterViewModel(filter)) {
                              <nts-zoom-filter-string-text-box
                                [filter]="filter"
                                [propertyViewModel]="filter.filterValue" (focus)="parameterFocus($event, filter)"
                                (keyDown)="keyDown($event)">
                              </nts-zoom-filter-string-text-box>
                            }
                          }
                          @if (isFilterNumeric(filter.filterValue) && !filter.showVariables) {
                            @if (isNumericZoomFilterViewModel(filter)) {
                              <nts-zoom-filter-numeric-text-box
                                [filter]="filter"
                                [propertyViewModel]="filter.filterValue" [updateOnBlur]="true"
                                (focus)="parameterFocus($event, filter)"
                                (keyDown)="keyDown($event)">
                              </nts-zoom-filter-numeric-text-box>
                            }
                          }
                          @if (isEnumZoomFilterViewModel(filter) && !filter.showVariables) {
                            @for (filterIn of filter.filterValues; track filterIn) {
                              <nts-zoom-filter-enum-text-box [propertyViewModel]="filterIn"
                                >
                              </nts-zoom-filter-enum-text-box>
                            }
                          }
                          @if (isExternalZoomFilterViewModel(filter) && !filter.showVariables) {
                            @for (filterIn of filter.filterValues; track filterIn) {
                              <nts-zoom-filter-external-text-box [filter]="filter"
                                [propertyViewModel]="getExternalZoomPropertyViewModel(filterIn)" (keyDown)="keyDown($event)"
                                [updateOnBlur]="true" (focus)="parameterFocus($event, filter)"
                                >
                              </nts-zoom-filter-external-text-box>
                            }
                          }
                          @if (isDateTimeZoomFilterViewModel(filter)) {
                            @if (isFilterDate(filter.filterValue) && !filter.showVariables) {
                              @for (filterIn of filter.filterDateTimeValues; track filterIn) {
                                <nts-zoom-filter-date-text-box [propertyViewModel]="getFilterDate(filterIn)"
                                  [ngClass]="'filter-value-text-in'">
                                </nts-zoom-filter-date-text-box>
                              }
                            }
                            @if (isFilterDateTimeOffset(filter.filterValue) && !filter.showVariables) {
                              @for (filterIn of filter.filterDateTimeValues; track filterIn) {
                                <nts-zoom-filter-date-offset-text-box [propertyViewModel]="getFilterDateTimeOffset(filterIn)"
                                  [ngClass]="'filter-value-text-in'">
                                </nts-zoom-filter-date-offset-text-box>
                              }
                            }
                          }
                        </div>
                      }
                      @if (isDateTimeZoomFilterViewModel(filter)) {
                        <div class="in-buttons-container"
                          >
                          @for (filterIn of filter.filterDateTimeValues; track filterIn; let last = $last; let first = $first) {
                            <div class="filter-value-actions"
                              >
                              @if (last) {
                                <nts-text-button
                                  [title]="zoomParametersViewModel.addInFieldButtonTitle" [icon]="'plus'"
                                  (onClicked)="zoomParametersViewModel.addInField(filter)">
                                </nts-text-button>
                              }
                              @if (!first) {
                                <nts-text-button
                                  [title]="zoomParametersViewModel.addInFieldButtonTitle" [icon]="'trash'"
                                  (onClicked)="zoomParametersViewModel.deleteInField(filter, filterIn)">
                                </nts-text-button>
                              }
                            </div>
                          }
                        </div>
                      }
                      @if (isEnumZoomFilterViewModel(filter)) {
                        <div class="in-buttons-container">
                          @for (filterIn of filter.filterValues; track filterIn; let last = $last; let first = $first) {
                            <div class="filter-value-actions"
                              >
                              @if (last) {
                                <nts-text-button
                                  [title]="zoomParametersViewModel.addInFieldButtonTitle" [icon]="'plus'"
                                  (onClicked)="zoomParametersViewModel.addInField(filter)">
                                </nts-text-button>
                              }
                              @if (!first) {
                                <nts-text-button
                                  [title]="zoomParametersViewModel.addInFieldButtonTitle" [icon]="'trash'"
                                  (onClicked)="zoomParametersViewModel.deleteInField(filter, filterIn)">
                                </nts-text-button>
                              }
                            </div>
                          }
                        </div>
                      }
                      @if (isExternalZoomFilterViewModel(filter)) {
                        <div class="in-buttons-container">
                          @for (filterIn of filter.filterValues; track filterIn; let last = $last; let first = $first) {
                            <div class="filter-value-actions"
                              >
                              @if (last) {
                                <nts-text-button
                                  [title]="zoomParametersViewModel.addInFieldButtonTitle" [icon]="'plus'"
                                  (onClicked)="zoomParametersViewModel.addInField(filter)">
                                </nts-text-button>
                              }
                              @if (!first) {
                                <nts-text-button
                                  [title]="zoomParametersViewModel.addInFieldButtonTitle" [icon]="'trash'"
                                  (onClicked)="zoomParametersViewModel.deleteInField(filter, filterIn)">
                                </nts-text-button>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        }
      </div>
    }

  </div>
  @if (zoomParametersViewModel.filters) {
    <nts-zoom-parameters-sorting-groups
      [class.is-hidden]="!zoomParametersViewModel.showSortingGroups"
      [parameters]="zoomParametersViewModel"
      (onSortingGroupsChanged)="zoomParametersViewModel.notifyModified()">
    </nts-zoom-parameters-sorting-groups>
  }